/**
 * DECOMURA CUSTOM: Moja Kolekcja — CollectionManager
 * Handles wishlist hearts, counters, golden flash, admin mode
 */
(function() {
  'use strict';
  if (window.__dcmCollectionManagerInit) return;
  window.__dcmCollectionManagerInit = true;


  // Wspólny adapter obu stron. Gdy localStorage jest zablokowany albo pełny,
  // zapis zostaje w tej karcie (sessionStorage), a ostatecznie w pamięci strony.
  const storage = window.__dcmCollectionStorage || (window.__dcmCollectionStorage = (() => {
    const memory = new Map();
    const prefix = 'dcm-storage-fallback:';
    return {
      getItem(key) {
        if (memory.has(key)) return memory.get(key);
        try {
          const temporary = window.sessionStorage.getItem(prefix + key);
          if (temporary !== null) return JSON.parse(temporary);
        } catch (_) {}
        try { return window.localStorage.getItem(key); } catch (_) { return null; }
      },
      setItem(key, value) {
        try {
          if (value === null) window.localStorage.removeItem(key);
          else window.localStorage.setItem(key, String(value));
          memory.delete(key);
          try { window.sessionStorage.removeItem(prefix + key); } catch (_) {}
          return;
        } catch (_) {}
        memory.set(key, value === null ? null : String(value));
        try { window.sessionStorage.setItem(prefix + key, JSON.stringify(value === null ? null : String(value))); } catch (_) {}
      },
      removeItem(key) { this.setItem(key, null); }
    };
  })());


  // Teksty pochodzą z sześciu plików locales, przekazanych przez Liquid.
  let dcmTexts = {};
  try { dcmTexts = JSON.parse(document.getElementById('dcm-staging-i18n').textContent); } catch (_) {}
  function dcmText(key, values) {
    let value = dcmTexts[key] || '';
    Object.keys(values || {}).forEach(name => { value = value.replaceAll('[' + name + ']', String(values[name])); });
    return value;
  }

  // --- Konfiguracja ---
  const API_BASE = 'https://decomura-erp.vercel.app/api/collection';
  const STORAGE_KEYS = {
    collection: 'decomura_collection',
    deviceId: 'decomura_device_id',
    adminMode: 'decomura_admin_mode',
    zgloszone: 'decomura_zgloszone_wzory',
  };
  const DEBOUNCE_MS = 300;
  const COUNTS_DEBOUNCE_MS = 150;
  const COUNTS_CACHE_MS = 10000;
  const ADMIN_SECRET_PARAM = 'admin';

  // --- State ---
  let savedHandles = new Set();
  let deviceId = '';
  let isAdminMode = false;
  // Bilet, nie sekret. Wyciek biletu kosztuje tyle, ile zostalo do jego wygasniecia.
  let adminBilet = '';
  let adminBiletDo = 0;
  const pendingToggles = new Map();
  let recentlyToggled = new Set();
  let countsFetchTimer = null;
  let countsFetchInFlight = false;
  let countsFetchQueued = false;
  let lastCountsRequestKey = '';
  let lastCountsRequestAt = 0;
  let lastCounts = null;

  // --- Init ---
  function init() {
    deviceId = getOrCreateDeviceId();
    savedHandles = readSavedHandles();
    
    checkAdminMode();
    hydrateHearts();
    scheduleFetchCounts();
    observeProductGrid();
    updateHeaderBadge();
    renderFloatingBadge();
  }

  // --- Device ID ---
  function getOrCreateDeviceId() {
    let id = storage.getItem(STORAGE_KEYS.deviceId);
    if (!id) {
      id = crypto.randomUUID ? crypto.randomUUID() : generateUUID();
      storage.setItem(STORAGE_KEYS.deviceId, id);
    }
    return id;
  }

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  // --- Tryb administratora: bilet zamiast wiecznego sekretu ---
  const KLUCZ_BILETU = 'decomura_admin_bilet';

  // sessionStorage, nie localStorage: bilet ma zginac razem z karta. `localStorage` byl wlasnie
  // tym miejscem, z ktorego kazdy skrypt na domenie mogl odczytac wieczny sekret.
  function czytajBilet() {
    try {
      const surowy = window.sessionStorage.getItem(KLUCZ_BILETU);
      if (!surowy) return null;
      const b = JSON.parse(surowy);
      if (!b || typeof b.token !== 'string' || typeof b.expiresAt !== 'number') return null;
      if (b.expiresAt <= Date.now()) { window.sessionStorage.removeItem(KLUCZ_BILETU); return null; }
      return b;
    } catch (_) { return null; }
  }

  function zapiszBilet(b) {
    try { window.sessionStorage.setItem(KLUCZ_BILETU, JSON.stringify(b)); } catch (_) {}
  }

  function zapomnijBilet() {
    try { window.sessionStorage.removeItem(KLUCZ_BILETU); } catch (_) {}
  }

  // Sprzatanie po starym mechanizmie: w przegladarkach, ktore wchodzily w tryb administratora
  // wczesniej, SUROWY sekret nadal lezy w `localStorage`. Kasujemy go przy kazdym wejsciu.
  function sprzatnijStarySekret() {
    try { window.localStorage.removeItem('decomura_admin_secret'); } catch (_) {}
    try { window.sessionStorage.removeItem('dcm_decomura_admin_secret'); } catch (_) {}
    storage.removeItem('decomura_admin_secret');
  }

  // Sekret pokazujemy serwerowi DOKLADNIE RAZ, w zamian za bilet. Nigdzie go nie zapisujemy.
  async function wymienSekretNaBilet(sekret) {
    const res = await fetch(API_BASE + '/admin-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sekret },
    });
    if (!res.ok) throw new Error('admin-session ' + res.status);
    const dane = await res.json();
    if (!dane || typeof dane.token !== 'string' || typeof dane.expiresAt !== 'number') {
      throw new Error('admin-session: zla odpowiedz');
    }
    return { token: dane.token, expiresAt: dane.expiresAt };
  }

  function wlaczTrybAdmina(bilet) {
    adminBilet = bilet.token;
    adminBiletDo = bilet.expiresAt;
    isAdminMode = true;
    storage.setItem(STORAGE_KEYS.adminMode, 'true');
    document.body.classList.add('dcm-admin-active');
    renderAdminBar();
    // Liczniki od nowa, bo wymiana sekretu na bilet jest asynchroniczna: `init()` zdazyl juz
    // pobrac je jako PUBLICZNE i zapisac pod kluczem `public|<uchwyt>`. Bez tej linii administrator
    // widzi swoj pasek i cudze liczby, i na nich ustawia podbicia. Lustro `__dcmDisableAdmin`,
    // ktore konczy sie tym samym wywolaniem.
    scheduleFetchCounts();
  }

  function checkAdminMode() {
    // Sekret zdejmuje z adresu skrypt na samej gorze `theme.liquid`, zeby nie zdazyl trafic do
    // nagran Clarity ani do analityki. Tutaj czytamy go juz tylko z pamieci strony. Odczyt z adresu
    // zostaje jako zapas na wypadek, gdyby ten skrypt kiedys zniknal z naglowka.
    const params = new URLSearchParams(window.location.search);
    const adminParam = window.__dcmAdmin || params.get(ADMIN_SECRET_PARAM);
    try { delete window.__dcmAdmin; } catch (_) { window.__dcmAdmin = undefined; }

    sprzatnijStarySekret();

    if (adminParam === 'off') {
      window.__dcmDisableAdmin();
      cleanAdminUrl();
      return;
    }

    if (adminParam) {
      cleanAdminUrl();
      // Nie wchodzimy w tryb administratora, dopoki serwer nie odda biletu. Bez biletu i tak
      // zadne dzialanie by nie przeszlo, wiec pasek bez pokrycia tylko wprowadzalby w blad.
      wymienSekretNaBilet(adminParam).then(function (bilet) {
        zapiszBilet(bilet);
        wlaczTrybAdmina(bilet);
      }).catch(function () {
        zapomnijBilet();
        storage.removeItem(STORAGE_KEYS.adminMode);
      });
      return;
    }

    const bilet = czytajBilet();
    if (bilet) wlaczTrybAdmina(bilet);
    else storage.removeItem(STORAGE_KEYS.adminMode);
  }

  // Kazde wywolanie do ERP w trybie administratora idzie przez to jedno miejsce: jesli bilet
  // wygasl po drodze, tryb gasnie od razu, zamiast zostawiac pasek, ktory niczego nie robi.
  function poswiadczenie() {
    if (!isAdminMode) return '';
    if (!adminBilet || adminBiletDo <= Date.now()) {
      window.__dcmDisableAdmin();
      return '';
    }
    return adminBilet;
  }

  function cleanAdminUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete(ADMIN_SECRET_PARAM);
    const state = Object.assign({}, window.history.state || {}, { searchParams: url.search.slice(1) });
    window.history.replaceState(state, '', url);
  }

  function renderAdminBar() {
    if (document.querySelector('.dcm-admin-bar')) return;

    const bar = document.createElement('div');
    bar.className = 'dcm-admin-bar';
    bar.innerHTML = `
      <div class="dcm-admin-bar__label">${escapeHtml(dcmText('admin_active'))}</div>
      <div class="dcm-admin-bar__actions">
        <button class="dcm-admin-bar__btn dcm-admin-bar__btn--reorder" onclick="window.__dcmReorder()">
          ${escapeHtml(dcmText('admin_sort'))}
        </button>
        <button class="dcm-admin-bar__btn dcm-admin-bar__btn--close" onclick="window.__dcmDisableAdmin()">
          ${escapeHtml(dcmText('admin_off'))}
        </button>
      </div>
    `;
    document.body.prepend(bar);
  }

  window.__dcmReorder = async function() {
    const btn = document.querySelector('.dcm-admin-bar__btn--reorder');
    if (!btn) return;
    btn.textContent = dcmText('admin_sorting');
    btn.disabled = true;
    try {
      const bilet = poswiadczenie();
      if (!bilet) { btn.textContent = dcmText('admin_error'); return; }
      const res = await fetch(API_BASE.replace('/collection', '/cron/reorder-collection'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + bilet,
        },
      });
      const data = await res.json();
      if (data.success) {
        btn.textContent = dcmText('admin_sorted');
        setTimeout(() => { btn.textContent = dcmText('admin_sort'); btn.disabled = false; }, 3000);
      } else {
        btn.textContent = dcmText('admin_error');
        setTimeout(() => { btn.textContent = dcmText('admin_sort'); btn.disabled = false; }, 5000);
      }
    } catch (err) {
      btn.textContent = dcmText('admin_network');
      setTimeout(() => { btn.textContent = dcmText('admin_sort'); btn.disabled = false; }, 5000);
    }
  };

  window.__dcmDisableAdmin = function() {
    storage.removeItem(STORAGE_KEYS.adminMode);
    zapomnijBilet();
    sprzatnijStarySekret();
    document.body.classList.remove('dcm-admin-active');
    const bar = document.querySelector('.dcm-admin-bar');
    if (bar) bar.remove();
    document.querySelectorAll('.dcm-admin-panel').forEach(p => p.remove());
    isAdminMode = false;
    adminBilet = '';
    adminBiletDo = 0;
    lastCounts = null;
    lastCountsRequestKey = '';
    scheduleFetchCounts();
  };

  // --- Hydrate Hearts ---
  function hydrateHearts() {
    document.querySelectorAll('.wishlist-badge:not(.hydrated)').forEach(badge => {
      const handle = badge.dataset.productHandle;
      if (!handle) return;

      badge.classList.add('hydrated');
      badge.classList.toggle('saved', savedHandles.has(handle));

      const btn = badge.querySelector('.wishlist-btn');
      if (btn) {
        btn.setAttribute('aria-pressed', String(savedHandles.has(handle)));
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleHeart(badge, handle);
        });
      }
    });
  }

  // --- Nazwane kolekcje: serca pokazują AKTYWNĄ kolekcję ---
  // Stary klucz `decomura_collection` jest tylko kopią kolekcji „_default" (tak używa go
  // moja-kolekcja.js: scala go do _default przy wczytaniu). Czytanie z niego stanu serc
  // powodowało, że po założeniu NOWEJ, pustej kolekcji listing pokazywał wzory zapisane
  // w poprzednich kolekcjach. Źródłem prawdy jest kolekcja aktywna.
  const COLLECTIONS_KEY = 'decomura_collections';
  const ACTIVE_KEY = 'decomura_active_collection';

  function validHandles(handles) {
    return Array.isArray(handles) ? [...new Set(handles.filter(h => typeof h === 'string' && /^[a-z0-9][a-z0-9_-]*$/.test(h)))] : [];
  }

  function readCollections() {
    let raw;
    try { raw = JSON.parse(storage.getItem(COLLECTIONS_KEY) || 'null'); } catch (_) {}
    const data = Object.create(null);
    if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
      Object.keys(raw).forEach(id => {
        const col = raw[id];
        if (col && typeof col === 'object' && Array.isArray(col.handles)) {
          data[id] = Object.assign({}, col, { handles: validHandles(col.handles) });
        }
      });
    }
    let legacy = [];
    try { legacy = validHandles(JSON.parse(storage.getItem(STORAGE_KEYS.collection) || '[]')); } catch (_) {}
    if (!data._default) data._default = { name: dcmText('collection_name'), handles: [] };
    // Zgodnie z migracją w moja-kolekcja.js: starsza karta mogła dopisać wzory do starego klucza.
    data._default.handles = [...new Set(data._default.handles.concat(legacy))];
    return data;
  }

  function getActiveId(data) {
    const id = storage.getItem(ACTIVE_KEY) || '_default';
    if ((data || readCollections())[id]) return id;
    storage.setItem(ACTIVE_KEY, '_default');
    return '_default';
  }

  function readSavedHandles() {
    const data = readCollections();
    return new Set(data[getActiveId(data)].handles);
  }

  function writeSavedHandles(handlesArray, data, id) {
    data[id].handles = validHandles(handlesArray);
    storage.setItem(COLLECTIONS_KEY, JSON.stringify(data));
    storage.setItem(STORAGE_KEYS.collection, JSON.stringify(data._default.handles));
    document.dispatchEvent(new CustomEvent('decomura:collection-changed', { detail: { source: 'hearts' } }));
  }

  /** Odświeżamy także nazwę i flagę udostępnienia przy identycznej zawartości kolekcji. */
  function refreshSavedState() {
    savedHandles = readSavedHandles();
    document.querySelectorAll('.wishlist-badge[data-product-handle]').forEach(badge => {
      const zapisane = savedHandles.has(badge.dataset.productHandle);
      badge.classList.toggle('saved', zapisane);
      const btn = badge.querySelector('.wishlist-btn');
      if (btn) btn.setAttribute('aria-pressed', String(zapisane));
    });
    updateHeaderBadge();
    renderFloatingBadge();
  }

  // --- Toggle Heart ---
  function toggleHeart(badge, handle) {
    // Ponowny odczyt przed kliknięciem chroni zmiany z drugiej karty, także przed zdarzeniem storage.
    const data = readCollections();
    const id = getActiveId(data);
    const wasAnywhere = Object.values(data).some(col => col.handles.includes(handle));
    savedHandles = new Set(data[id].handles);
    const wasSaved = savedHandles.has(handle);
    if (wasSaved) savedHandles.delete(handle); else savedHandles.add(handle);
    writeSavedHandles([...savedHandles], data, id);
    const isAnywhere = Object.values(data).some(col => col.handles.includes(handle));
    refreshSavedState();
    renderFloatingBadge(true);

    if (!wasSaved) {
      const btn = badge.querySelector('.wishlist-btn');
      if (btn) {
        btn.classList.add('golden-flash');
        setTimeout(() => btn.classList.remove('golden-flash'), 800);
      }
    }
    // ERP ma jeden stan na urządzenie i wzór, bez identyfikatora nazwanej kolekcji.
    // Przenoszenie lub zapis do drugiej kolekcji nie jest kolejnym głosem.
    if (wasAnywhere === isAnywhere) return;
    if (isAnywhere) zglosDoErp(handle);
  }

  // Decyzja właściciela z 11.09.2026: licznik serc idzie TYLKO W GÓRĘ. Odkliknięcie nie zdejmuje
  // głosu, a jedno urządzenie liczy dany wzór raz. Punkt końcowy ERP przełącza stan na parze
  // urządzenie–wzór, więc drugie wywołanie dla tego samego urządzenia by odejmowało — stąd lista
  // wzorów już zgłoszonych, trzymana obok identyfikatora urządzenia i kasowana razem z nim.
  function juzZgloszone() {
    try { return new Set(JSON.parse(storage.getItem(STORAGE_KEYS.zgloszone) || '[]')); } catch (_) { return new Set(); }
  }
  function zapiszZgloszone(zbior) {
    try { storage.setItem(STORAGE_KEYS.zgloszone, JSON.stringify([...zbior])); } catch (_) {}
  }
  function odznaczZgloszenie(handle) {
    const zbior = juzZgloszone();
    if (!zbior.delete(handle)) return;
    zapiszZgloszone(zbior);
  }

  function zglosDoErp(handle) {
    const zbior = juzZgloszone();
    if (zbior.has(handle)) return;
    // Znacznik przed wysyłką: dwa szybkie kliknięcia nie mogą wysłać dwóch przełączeń.
    zbior.add(handle);
    zapiszZgloszone(zbior);
    recentlyToggled.add(handle);
    setTimeout(() => recentlyToggled.delete(handle), 3000);
    document.querySelectorAll('.wishlist-badge[data-product-handle]').forEach(b => {
      if (b.dataset.productHandle !== handle) return;
      const count = b.querySelector('.wishlist-count');
      if (count) count.textContent = (parseInt(count.textContent, 10) || 0) + 1;
    });
    let pending = pendingToggles.get(handle);
    if (!pending) {
      pending = { odd: false, busy: false, timer: null };
      pendingToggles.set(handle, pending);
    }
    // Na wzór przypada najwyżej jedno wysłane zgłoszenie, więc nie ma czego znosić.
    pending.odd = true;
    clearTimeout(pending.timer);
    pending.timer = setTimeout(() => { kolejkaToggle.push(() => flushToggle(handle, pending)); pompujToggle(); }, DEBOUNCE_MS);
  }

  // Wyczyszczenie kolekcji potrafi zgłosić kilkadziesiąt wzorów naraz — wypuszczamy je porcjami.
  const kolejkaToggle = [];
  let aktywneToggle = 0;
  function pozToggle() { aktywneToggle--; pompujToggle(); }
  function pompujToggle() {
    while (aktywneToggle < 4 && kolejkaToggle.length) {
      aktywneToggle++;
      kolejkaToggle.shift()().then(pozToggle, pozToggle);
    }
  }

  async function flushToggle(handle, pending) {
    if (pending.busy || !pending.odd) return;
    pending.odd = false;
    pending.busy = true;
    try {
      const res = await fetch(API_BASE + '/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handle, deviceId }),
      });
      if (!res.ok) throw new Error('API error ' + res.status);
      const data = await res.json();
      if (!pending.odd && Number.isFinite(data.count)) {
        document.querySelectorAll('.wishlist-badge[data-product-handle]').forEach(b => {
          if (b.dataset.productHandle !== handle) return;
          const count = b.querySelector('.wishlist-count');
          if (count) count.textContent = data.count;
        });
      }
      // data.saved dotyczy ERP, nie aktywnej kolekcji. Odpowiedź nigdy nie zmienia lokalnych zapisów.
    } catch (err) {
      // Zgłoszenie nie doszło — zdejmujemy znacznik, żeby wzór mógł policzyć się przy kolejnej okazji.
      // Brak odpowiedzi licznika nie usuwa zapisanych wzorów i nie modyfikuje innej kolekcji.
      odznaczZgloszenie(handle);
      console.warn('[Moja Kolekcja] Nie udało się odświeżyć licznika:', err);
    } finally {
      pending.busy = false;
      lastCountsRequestAt = 0;
      countsCache.delete('public|' + handle);
      countsCache.delete('admin|' + handle);
      if (pending.odd) flushToggle(handle, pending);
      else pendingToggles.delete(handle);
    }
  }

  // Jeden wspólny odczyt dla serc, galerii i menu. Maksymalnie dwie paczki po 50.
  const countsCache = new Map();
  const countsPending = new Map();
  const countsWaiting = [];
  let countsActive = 0;
  let countsBatchTimer = null;
  let countsCooldownUntil = 0;
  function requestCounts(handles) {
    const unique = [...new Set(handles)].filter(handle => typeof handle === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/.test(handle));
    const mode = isAdminMode && adminBilet ? 'admin' : 'public';
    const promises = unique.map(handle => {
      const key = mode + '|' + handle;
      const saved = countsCache.get(key);
      if (saved && Date.now() - saved.time < 30000) return Promise.resolve([handle, saved.value]);
      if (countsCooldownUntil > Date.now()) return Promise.reject(new Error('Przerwa po błędzie liczników'));
      if (!countsPending.has(key)) {
        let resolve, reject;
        const promise = new Promise((yes,no) => { resolve=yes; reject=no; });
        const job = {key,handle,mode,secret:mode === 'admin' ? adminBilet : '',promise,resolve,reject};
        countsPending.set(key,job); countsWaiting.push(job);
      }
      return countsPending.get(key).promise.then(value => [handle,value]);
    });
    if (!countsBatchTimer) countsBatchTimer = setTimeout(() => { countsBatchTimer=null; pumpCounts(); }, 35);
    return Promise.all(promises).then(pairs => Object.fromEntries(pairs));
  }
  function pumpCounts() {
    while (countsActive < 2 && countsWaiting.length) {
      const mode = countsWaiting[0].mode;
      const batch = [];
      for (let i=0; i<countsWaiting.length && batch.length<50;) {
        if (countsWaiting[i].mode === mode) batch.push(countsWaiting.splice(i,1)[0]); else i++;
      }
      countsActive++;
      fetchCountsBatch(batch);
    }
  }
  async function fetchCountsBatch(batch) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(),15000);
    try {
      const headers = {};
      if (batch[0].secret) headers.Authorization = 'Bearer ' + batch[0].secret;
      const response = await fetch(API_BASE + '/counts?handles=' + batch.map(job=>encodeURIComponent(job.handle)).join(','), {headers,signal:controller.signal});
      if (!response.ok) throw new Error('Liczniki HTTP ' + response.status);
      const data = await response.json();
      if (!data.counts || typeof data.counts !== 'object') throw new Error('Nieprawidłowe liczniki');
      // Brak wartości nie oznacza zera: nie tasujemy kafla na podstawie niepełnej odpowiedzi.
      for (const job of batch) {
        const value = data.counts[job.handle];
        const total = typeof value === 'object' && value ? value.total : value;
        if (!Number.isFinite(total) || total < 0) throw new Error('Brak poprawnego licznika');
      }
      for (const job of batch) {
        const value = data.counts[job.handle];
        countsCache.set(job.key,{value,time:Date.now()});
        job.resolve(value);
      }
    } catch (error) {
      countsCooldownUntil=Date.now()+30000;
      batch.forEach(job=>job.reject(error));
      countsWaiting.splice(0).forEach(job=>{countsPending.delete(job.key);job.reject(error);});
    } finally {
      clearTimeout(timer);
      batch.forEach(job=>countsPending.delete(job.key));
      countsActive--; pumpCounts();
    }
  }
  window.DcmCounts = {get:requestCounts};
  document.dispatchEvent(new CustomEvent('dcm:counts:ready'));
  function scheduleFetchCounts() {
    clearTimeout(countsFetchTimer);
    countsFetchTimer = setTimeout(fetchCounts, COUNTS_DEBOUNCE_MS);
  }
  async function fetchCounts() {
    if (countsFetchInFlight) { countsFetchQueued=true; return; }
    const badges = [...document.querySelectorAll('.wishlist-badge[data-product-handle]')]
      .filter(badge => isAdminMode || (!badge.closest('[data-dcm-card]') && !badge.closest('.product__info-wrapper')?.querySelector('[data-dcm-pb]')));
    if (!badges.length) return;
    countsFetchInFlight=true;
    try {
      const counts=await requestCounts(badges.map(badge=>badge.dataset.productHandle));
      lastCounts=counts;
      lastCountsRequestAt=Date.now();
      applyCounts(counts,badges.filter(badge=>badge.isConnected));
    } catch (_) { /* Niedostępne liczniki nie zmieniają zapisów klienta. */ }
    finally {
      countsFetchInFlight=false;
      if (countsFetchQueued) { countsFetchQueued=false; scheduleFetchCounts(); }
    }
  }

  function applyCounts(counts, badges) {
      badges.forEach(badge => {
        badge.dataset.dcmCountsReady = 'true';
        const handle = badge.dataset.productHandle;
        const countEl = badge.querySelector('.wishlist-count');

        // Skip if recently toggled — don't overwrite optimistic value
        if (recentlyToggled.has(handle)) return;
        
        if (isAdminMode && counts[handle] && typeof counts[handle] === 'object') {
          // Admin: show total, render admin panel
          if (countEl) countEl.textContent = counts[handle].total || 0;
          renderAdminPanel(badge, handle, counts[handle]);
        } else {
          // Public: simple count
          const count = typeof counts[handle] === 'object' ? counts[handle].total : (counts[handle] || 0);
          if (countEl) countEl.textContent = count;
        }
      });

      // Notify smart-filters.js that counts are ready for sorting
      document.dispatchEvent(new CustomEvent('decomura:hearts-loaded'));
  }

  // --- Admin Panel on Cards ---
  function renderAdminPanel(badge, handle, countData) {
    if (!isAdminMode) return;
    
    // Find the card__inner parent
    const card = badge.closest('.dcm-card__media') || badge.closest('.card__inner') || badge.closest('.card') || badge.closest('.product__info-container');
    if (!card || card.querySelector('.dcm-admin-panel')) return;

    const panel = document.createElement('div');
    panel.className = 'dcm-admin-panel';
    panel.innerHTML = `
      <div class="dcm-admin-panel__stats">
        <span>${escapeHtml(dcmText('admin_organic'))}: ${countData.organic || 0}</span>
        <span>${escapeHtml(dcmText('admin_boost'))}: ${countData.boost || 0}</span>
      </div>
      <div class="dcm-admin-panel__form">
        <input class="dcm-admin-panel__input" type="number" min="0" max="99999" 
               value="${countData.boost || 0}" placeholder="${escapeHtml(dcmText('admin_boost'))}" aria-label="${escapeHtml(dcmText('admin_boost'))}" data-handle="${handle}">
        <button class="dcm-admin-panel__save" data-handle="${handle}">${escapeHtml(dcmText('admin_save'))}</button>
      </div>
    `;

    const saveBtn = panel.querySelector('.dcm-admin-panel__save');
    const input = panel.querySelector('.dcm-admin-panel__input');

    saveBtn.addEventListener('click', async () => {
      const newBoost = parseInt(input.value) || 0;
      saveBtn.textContent = '...';
      saveBtn.disabled = true;

      try {
        const bilet = poswiadczenie();
        if (!bilet) throw new Error('Bilet administratora wygasl');
        const res = await fetch(API_BASE + '/boost', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + bilet,
          },
          body: JSON.stringify({ handle, boostCount: newBoost }),
        });

        if (!res.ok) throw new Error('Boost API error');
        const data = await res.json();

        // Update counter
        const countEl = badge.querySelector('.wishlist-count');
        if (countEl) countEl.textContent = data.total;

        // Update stats
        const stats = panel.querySelector('.dcm-admin-panel__stats');
        if (stats) stats.innerHTML = `<span>${escapeHtml(dcmText('admin_organic'))}: ${data.organic}</span><span>${escapeHtml(dcmText('admin_boost'))}: ${data.boost}</span>`;

        saveBtn.textContent = '✅';
        saveBtn.classList.add('dcm-admin-panel__save--saved');
        setTimeout(() => {
          saveBtn.textContent = dcmText('admin_save');
          saveBtn.classList.remove('dcm-admin-panel__save--saved');
          saveBtn.disabled = false;
        }, 2000);
      } catch (err) {
        saveBtn.textContent = dcmText('admin_error');
        setTimeout(() => { saveBtn.textContent = dcmText('admin_save'); saveBtn.disabled = false; }, 3000);
      }
    });

    card.style.position = 'relative';
    card.appendChild(panel);
  }

  // --- Header Badge ---
  function updateHeaderBadge() {
    const badge = document.querySelector('.header-wishlist-count');
    if (badge) {
      badge.textContent = savedHandles.size;
      badge.style.display = savedHandles.size > 0 ? 'inline-flex' : 'none';
    }
  }

  // --- Floating Collection Badge (shown when non-default collection is active) ---
  const BADGE_DISMISSED_KEY = 'dcm_badge_dismissed';

  function readDismissedBadge() {
    try { return sessionStorage.getItem(BADGE_DISMISSED_KEY); } catch (_) { return null; }
  }

  function renderFloatingBadge(forceShow) {
    const COLLECTIONS_KEY = 'decomura_collections';
    const ACTIVE_KEY = 'decomura_active_collection';

    // Don't show on moja-kolekcja page (it has its own UI)
    if (window.location.pathname.includes('moja-kolekcja')) {
      const existing = document.getElementById('dcm-floating-badge');
      if (existing) existing.remove();
      return;
    }

    const activeId = storage.getItem(ACTIVE_KEY) || '_default';
    if (activeId === '_default') {
      // Remove badge if exists
      const existing = document.getElementById('dcm-floating-badge');
      if (existing) existing.remove();
      return;
    }

    // Check if badge was dismissed (unless forceShow after adding a pattern)
    if (!forceShow && readDismissedBadge() === activeId) {
      const existing = document.getElementById('dcm-floating-badge');
      if (existing) existing.remove();
      return;
    }

    // Get collection data
    let collectionName = '';
    let collectionCount = 0;
    let isShared = false;
    try {
      const raw = storage.getItem(COLLECTIONS_KEY);
      if (raw) {
        const data = JSON.parse(raw);
        if (data[activeId]) {
          collectionName = data[activeId].name || dcmText('collection_name');
          collectionCount = (data[activeId].handles || []).length;
          isShared = !!data[activeId].shared;
        } else {
          // Active collection doesn't exist anymore, reset
          storage.setItem(ACTIVE_KEY, '_default');
          const existing = document.getElementById('dcm-floating-badge');
          if (existing) existing.remove();
          return;
        }
      }
    } catch (_) { return; }

    // Clear dismissed flag when showing (e.g. after forceShow)
    if (forceShow) {
      try { sessionStorage.removeItem(BADGE_DISMISSED_KEY); } catch (_) {}
    }

    // Create or update badge
    let badge = document.getElementById('dcm-floating-badge');
    if (!badge) {
      badge = document.createElement('a');
      badge.id = 'dcm-floating-badge';
      badge.href = (window.Shopify?.routes?.root || '/') + 'pages/moja-kolekcja';
      badge.className = 'dcm-floating-badge';
      const mainContent = document.getElementById('MainContent');
      if (mainContent) mainContent.insertAdjacentElement('beforebegin', badge);
      else document.body.appendChild(badge);
    }

    const icon = isShared ? '📩' : '📂';
    badge.innerHTML = `
      <span class="dcm-floating-badge__icon">${icon}</span>
      <span class="dcm-floating-badge__name">${escapeHtml(collectionName)}</span>
      <span class="dcm-floating-badge__count">${collectionCount}</span>
      <button class="dcm-floating-badge__close" aria-label="${escapeHtml(dcmText('close'))}" title="${escapeHtml(dcmText('close'))}" onclick="event.preventDefault();event.stopPropagation();window.__dcmDismissBadge();">✕</button>
    `;
    badge.style.display = 'flex';
    // Reset animacji (mogła zostać slide-out z dismiss)
    badge.style.animation = 'none';
    badge.offsetHeight; // force reflow
    badge.style.animation = 'dcm-badge-slide-in 0.4s ease-out';
  }

  // Global dismiss handler
  window.__dcmDismissBadge = function() {
    const badge = document.getElementById('dcm-floating-badge');
    if (!badge) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      badge.style.display = 'none';
      try { sessionStorage.setItem(BADGE_DISMISSED_KEY, storage.getItem('decomura_active_collection') || '_default'); } catch (_) {}
      return;
    }
    // Animacja zamknięcia.
    badge.style.animation = 'dcm-badge-slide-out 0.3s ease-in forwards';
    badge.addEventListener('animationend', function() {
      badge.style.display = 'none';
      // Remember dismissed for this collection in this session
      const activeId = storage.getItem('decomura_active_collection') || '_default';
      try { sessionStorage.setItem(BADGE_DISMISSED_KEY, activeId); } catch (_) {}
    }, { once: true });
  };

  function escapeHtml(str) {
    const el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }

  // --- MutationObserver (for AJAX pagination) ---
  function observeProductGrid() {
    const grid = document.getElementById('MainContent') || document.body;
    if (!grid) return;

    function isProductNode(node) {
      if (!node || node.nodeType !== Node.ELEMENT_NODE) return false;
      return (
        node.matches('.grid__item, .card-wrapper, .wishlist-badge, [data-product-handle]') ||
        Boolean(node.querySelector('.grid__item, .card-wrapper, .wishlist-badge, [data-product-handle]'))
      );
    }

    const observer = new MutationObserver((mutations) => {
      let hasNewNodes = false;
      mutations.forEach(m => {
        if (m.type === 'attributes' && m.target.matches('.wishlist-badge')) {
          const btn = m.target.querySelector('.wishlist-btn');
          if (btn) btn.setAttribute('aria-pressed', String(m.target.classList.contains('saved')));
        }
        m.addedNodes.forEach(node => {
          if (isProductNode(node)) hasNewNodes = true;
        });
      });
      if (hasNewNodes) {
        savedHandles = readSavedHandles();
        hydrateHearts();
        scheduleFetchCounts();
      }
    });

    observer.observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // --- Start ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Zmiana aktywnej kolekcji w innej karcie albo powrót z „Moja Kolekcja" (bfcache):
  // serca muszą pokazywać zawartość kolekcji, która jest aktywna TERAZ.
  window.addEventListener('storage', (e) => {
    if (!e.key || e.key === COLLECTIONS_KEY || e.key === ACTIVE_KEY || e.key === STORAGE_KEYS.collection) { refreshSavedState(); zsynchronizujZErp(false); }
  });
  // Migawka wszystkich zapisanych wzorów. Po zmianie spoza serc (strona „Moja Kolekcja”,
  // import) różnica mówi, które wzory doszły i trzeba je zgłosić.
  let znaneWzory = null;
  function wzoryZapisane() {
    const zbior = new Set();
    const dane = readCollections();
    Object.keys(dane).forEach(id => (dane[id].handles || []).forEach(h => zbior.add(h)));
    return zbior;
  }
  function zsynchronizujZErp(zglaszaj) {
    const teraz = wzoryZapisane();
    if (znaneWzory && zglaszaj) {
      // Tylko przybytki: usunięcie wzoru nie zdejmuje głosu (decyzja właściciela z 11.09.2026).
      teraz.forEach(h => { if (!znaneWzory.has(h)) zglosDoErp(h); });
    }
    znaneWzory = teraz;
  }
  zsynchronizujZErp(false);
  document.addEventListener('decomura:collection-changed', (e) => {
    refreshSavedState();
    // Ścieżka serc zgłasza się sama; tu tylko dosuwamy migawkę, żeby nie policzyć zmiany dwa razy.
    zsynchronizujZErp(!e.detail || e.detail.source !== 'hearts');
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) { refreshSavedState(); zsynchronizujZErp(false); } });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) { refreshSavedState(); zsynchronizujZErp(false); } });
})();
